import axios from '@/services/axios.js'
import type { User } from '@/types/user'
import type { PersonRole } from '@/types/role'

export async function getUserData(): Promise<User> {
  const response = await axios.get('/api/user/profile')
  return response.data?.user
}

export async function updateUserData(user: User | null): Promise<{ message: string }> {
  const response = await axios.post('/api/user/details', user)
  return response.data
}

export async function getUserRolesData(): Promise<PersonRole[]> {
  const response = await axios.get('/api/user/roles')
  return response.data?.roles
}
